module.exports = __webpack_public_path__ + "img/sightseer-tips-icon.b3cb51dc.png";